import { GET_LABOR_SUCCESS, CREATE_LABOR_SUCCESS, UPDATE_LABOR_SUCCESS, DELETE_LABOR_SUCCESS, GET_BULK_LABOR_SUCCESS, REORDER_LABOR_SUCCESS } from './labor.types';

const initialState = { laborEntries: [], bulkLabor: {} };

export const laborReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LABOR_SUCCESS:
      return { ...state, laborEntries: action.payload };
    case CREATE_LABOR_SUCCESS: {
      const newEntry = action.payload;
      const taskId = typeof newEntry.task === 'object' ? newEntry.task._id : newEntry.task;
      return {
        ...state,
        laborEntries: [newEntry, ...state.laborEntries],
        bulkLabor: {
          ...state.bulkLabor,
          [taskId]: [...(state.bulkLabor[taskId] || []), newEntry],
        },
      };
    }
    case UPDATE_LABOR_SUCCESS: {
      const updated = action.payload;
      // Also update bulkLabor so board/tasks page reflects changes immediately
      const newBulk = { ...state.bulkLabor };
      if (Array.isArray(updated)) {
        // When status is set to complete, backend returns the full task labor list
        if (updated.length > 0) {
          const tid = typeof updated[0].task === 'object' ? updated[0].task._id : updated[0].task;
          if (tid) newBulk[tid] = updated;
        }
      } else {
        const tid = typeof updated.task === 'object' ? updated.task._id : updated.task;
        if (tid && newBulk[tid]) {
          newBulk[tid] = newBulk[tid].map((l) => l._id === updated._id ? updated : l);
        }
      }
      return {
        ...state,
        laborEntries: Array.isArray(updated)
          ? updated
          : state.laborEntries.map((l) => l._id === updated._id ? updated : l),
        bulkLabor: newBulk,
      };
    }
    case DELETE_LABOR_SUCCESS:
      return { ...state, laborEntries: state.laborEntries.filter((l) => l._id !== action.payload) };
    case GET_BULK_LABOR_SUCCESS:
      return { ...state, bulkLabor: action.payload };
    case REORDER_LABOR_SUCCESS:
      return { ...state, laborEntries: action.payload };
    default:
      return state;
  }
};
